export const IMAGENIE_LOCAL_FORAGE_CONFIG = {
  name: 'imagenie_db',
  storeName: 'image',
  description: 'The database to hold base 64 versions of all your images so they are available offline'
};

export class ImagenieUtil {
  static getImageBase64String(url, outputFormat) {
    var imageBase64StringPromise = Promise.defer();

    var canvas = document.createElement('CANVAS'),
      ctx = canvas.getContext('2d'),
      img = new Image;
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
      var dataURL;
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      dataURL = canvas.toDataURL(outputFormat);
      canvas = null;
      imageBase64StringPromise.resolve(dataURL);
    };
    img.onerror = function () {
      imageBase64StringPromise.reject(url);
    };
    img.src = url;
    return imageBase64StringPromise.promise;
  }

  static isUndefined(value) {
    return typeof value === 'undefined';
  }

  static isEmpty(value) {
    return ImagenieUtil.isUndefined(value) || value === '' || value === null;
  }

  static getImageSrc(elementAttributes) {
    if (!ImagenieUtil.isEmpty(elementAttributes.imagenie)) {
      return elementAttributes.imagenie;
    } else if (!ImagenieUtil.isEmpty(elementAttributes.ngSrc)) {
      return elementAttributes.ngSrc;
    } else if (!ImagenieUtil.isEmpty(elementAttributes.src)) {
      return elementAttributes.src;
    } else {
      console.warn('Image Src Undefined');
      return null;
    }
  }

  static setImageToElement(element, imageBase64String) {
    if (element[0].nodeName === 'IMG') {
      element.attr('src', imageBase64String);
    } else {
      element.css('background-image', 'url(' + imageBase64String + ')');
    }
  }

  static isUriAbsolute(uri) {
    //****************
    //http://stackoverflow.com/questions/10687099/how-to-test-if-a-url-string-is-absolute-or-relative
    //****************
    var uriTypeRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
    return uriTypeRegex.test(uri);
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/imagenie/index.js